<template lang="pug">
v-app
  home-app-bar
  v-main
    v-fade-transition(mode='out-in')
      v-container(fluid class="pa-0")
        nuxt-page
  home-footer
</template>

<script setup>
import HomeAppBar from '~/layouts/AppBar.vue'
import HomeFooter from '~/layouts/Footer.vue'
</script>
